import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { WindyTypes } from '@dashboard/dashboard-store';
import { WeatherDataService } from '@widgets/map-widget/services/weather-data.service';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-weather-config',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NzModalModule],
  templateUrl: './weather-config.component.html',
  styleUrl: './weather-config.component.scss',
})
export class WeatherConfigComponent implements OnInit {
  velocityForm: FormGroup;
  @Input() config: WindyTypes;
  readonly modal = inject(NzModalRef);
  weatherTypes = ['wind', 'wave', 'currents'];
  prevData: any = {};
  constructor(
    private fb: FormBuilder,
    private weatherSrv: WeatherDataService
  ) {
    this.velocityForm = this.fb.group({
      minVelocity: [],
      maxVelocity: [],
      velocityScale: [],
      colorScale: '',
      particleMultiplier: [],
      lineWidth: [],
      weatherType: [],
    });
  }
  ngOnInit(): void {
    this.velocityForm.controls.weatherType.valueChanges.subscribe((wtype) => {
      this.updateForm(wtype);
    });
  }

  private updateForm(wtype: WindyTypes): void {
    const config = this.weatherSrv.DefaultWeatherConfig[wtype];
    this.prevData = config;
    const colors = config.colorScale;
    this.velocityForm.patchValue({
      minVelocity: config.minVelocity,
      maxVelocity: config.maxVelocity,
      velocityScale: config.velocityScale,
      colorScale: colors ? colors.join(',') : '',
      particleMultiplier: config.particleMultiplier,
      lineWidth: config.lineWidth,
    });
  }

  destroyModal(): void {
    this.modal.destroy({ data: 'this the result data' });
  }

  onSubmit(): void {
    if (this.velocityForm.valid) {
      const colors = this.velocityForm.value.colorScale || '';
      const data = this.velocityForm.value;
      if (!this.prevData.initColors && !colors) {
        delete data.colorScale;
      } else if (!colors) {
        delete data.colorScale;
      }
      {
        data['colorScale'] = colors.split(',');
      }
      this.modal.destroy(data);
    }
  }
}
